import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";
import { getFirstUnlockedTabPath, isTabLocked } from "../utils/adminTabAccess";

function ProtectedRoute({ path, children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  if (path && isTabLocked(path)) {
    const fallbackPath = getFirstUnlockedTabPath() || "/dashboard";
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
}

export default ProtectedRoute;
